$(window).load(function() {
	wscreen();
});
$(window).resize(function() {
	wscreen();
});

function wscreen() {
	var windowhegiht = window.innerWidth / 1200;
	var bannerheght = windowhegiht * 750; //原始高度

	if(window.innerWidth <= 1200) {
		$(".banner").height(bannerheght);
	}
};



// WEBPACK FOOTER //
// ./E:/airwheel.net/Content/js/banner.js